import PropTypes from "prop-types";
import React from "react";

import { FormGroupTitle, FormSwitchField, FormTextField } from "ui/Form";
import DialogFormWithMutation from "dialogs/DialogFormWithMutation";

import { addFeatureGroupValidator } from "validators/addFeatureGroupValidator";
import {
  ADD_FEATURE_TYPE,
  GET_LICENSE_FEATURE_GROUP_NAME,
} from "graphqlQueries/licenses";

const fieldsWithPlaceForError = ["name", "description"];

const AddFeatureTypeDialog = (props) => {
  const initialValues = {
    name: "",
    description: "",
    is_enabled_by_default: true,
    id_feature_group: props.groupId,
  };

  return (
    <DialogFormWithMutation
      mutationQueries={ADD_FEATURE_TYPE}
      refetchQueries={[GET_LICENSE_FEATURE_GROUP_NAME]}
      initialValues={initialValues}
      validationSchema={addFeatureGroupValidator}
      fieldsWithPlaceForError={fieldsWithPlaceForError}
      title="New type"
      submitButtonName="Save"
      className="dialog-default-width"
      {...props}
    >
      <FormGroupTitle title="Type information" />
      <FormTextField name="name" label="Name" />
      <FormTextField name="description" label="Description" />
      <FormSwitchField
        name="is_enabled_by_default"
        label="Enabled by default"
      />
    </DialogFormWithMutation>
  );
};

AddFeatureTypeDialog.propTypes = {
  groupId: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default AddFeatureTypeDialog;
